import { cookie, Event, jsonp } from '@ifeng-fe/ui_base';

// 登录地址
export const LOGINURL = '//user.ifeng.com/allsite/login';

// 实名认证地址
const LOGINMOB = '//user.ifeng.com/allsite/loginmob';

// 登录退出接口
const LOGOUTURL = '//id.ifeng.com/index.php/api/logout';

// 远程验证sid接口
const CHECKLOGINURL = '//id.ifeng.com/api/checklogin';

/**
 * 创建登录窗口的uuid，主要用于避免自定义事件触发多个弹窗出现。
 */
export const uuid = function uuid() {
    return `dialog_${Math.floor(Math.random() * Date.now())}`;
};

/**
 * event 中注册的自定义事件
 *
 * login 登录
 * logout 登出
 * dialogOpen 弹窗打开
 * dialogClose 弹窗关闭
 * urlChange 改变弹窗ifram的地址
 */
export const EVENTNAMES = {
    login: 'login',
    logout: 'logout',
    dialogOpen: 'dialogOpen',
    dialogClose: 'dialogClose',
    urlChange: 'urlChange',
};

let LOGINTIMER = null;
let REALTIMER = null;
let OTKTIMER = null;
let LOGOUTTIMER = null;

/**
 * 创建一个自定义事件
 */

// WHALE_PC_AUTH_EVENT 放置由于组件被打包到多个文件中导致 event 变成多个而使事件源变成多个而无法相互通信的问题。
// 这个是个防御性措施。
export const event = typeof window !== 'undefined' ? window.WHALE_PC_AUTH_EVENT || new Event() : new Event();

if (typeof window !== 'undefined') {
    if (!window.WHALE_PC_AUTH_EVENT) {
        window.WHALE_PC_AUTH_EVENT = event;
    }
}

/**
 * 判断用户是否实名
 *
 * 规则，cookie 中 sid 存在并且 IF_REAL 为 0
 * @return {Boolean} 是否登录
 */
export const isReal = function isReal() {
    return !!(cookie.get('sid') && cookie.get('IF_REAL') === '0');
};

/**
 * 判断用户是否登录
 *
 * 规则，cookie 中 sid 存在
 * @return {Boolean} 是否登录
 */
export const isLogin = function isLogin() {
    return !!cookie.get('sid');
};

/**
 * 获取用户信息
 * @returns {Object} 返回用户信息 {sid(sid), userName(用户名), isReal(是否实名)}
 */
export const getUserInfo = function getUserInfo() {
    return {
        sid: cookie.get('sid'),
        userName: cookie.get('IF_USER'),
        isReal: isReal(),
    };
};

/**
 * 用户登录检测，流程：
 *
 * 1. 开启用户登录检测
 * 2. 判断用户是否登录
 *
 * 用户登录
 * 3. 触发自定义事件 login, 并将用户信息通过自定义事件传出去
 * 4. 清除用户登录检测
 * 5. 清除第三方登录检测
 */
const checkLogin = function checkLogin() {
    clearInterval(LOGINTIMER);
    LOGINTIMER = setInterval(() => {
        if (isLogin()) {
            event.trigger(EVENTNAMES.login, getUserInfo());
            clearInterval(LOGINTIMER);

            if (!cookie.get('IF_OTK')) {
                clearInterval(OTKTIMER);
            }
        }
    }, 300);
};

/**
 * 检测实名，流程：
 *
 * 1. 开启定时器
 * 2. 判断用户是否实名
 *
 * 实名登录成功
 * 3. 触发自定义事件 dialogClose
 * 4. 清除实名检测定时器
 *
 */
const checkReal = function checkReal() {
    clearInterval(REALTIMER);
    REALTIMER = setInterval(() => {
        if (isReal()) {
            setTimeout(() => {
                event.trigger(EVENTNAMES.dialogClose);
            }, 300);
            clearInterval(REALTIMER);
        } else if (cookie.get('sid')) {
            event.trigger(EVENTNAMES.urlChange, LOGINMOB);
        }
    }, 300);
};

/**
 * 第三方登录检测，流程：
 *
 * 1. 开启定时器
 * 2. 当探测到第三方登录的cookie以后，将cookie内容序列化为一个json对象
 *
 * 序列化成功，返回 code 为 1
 * 3. 停掉定时器
 * 4. 删除第三方cookie
 * 5. 根据返回的数据的 data.url 更改登录框的iframe的src
 *
 * 序列化成功，返回 code 不为 1
 * 3. 将登录框的iframe重置为 LOGINURL，
 * 4. 如果返回的数据有 message，则弹出
 *
 * 序列化失败
 * 3. 弹出失败信息
 */
const checkOTK = function checkOTK() {
    cookie.del('IF_OTK', '/', '.ifeng.com');
    clearInterval(OTKTIMER);

    OTKTIMER = setInterval(() => {
        const otk = cookie.get('IF_OTK');

        if (otk.trim()) {
            clearInterval(OTKTIMER);
            try {
                const result = new Function(`return ${otk}`)();

                cookie.del('IF_OTK', '/', '.ifeng.com');

                if (result.code === 1 || result.code === 'OK') {
                    if (result.data && result.data.url) {
                        event.trigger(EVENTNAMES.urlChange, result.data.url);
                    }
                } else {
                    event.trigger(EVENTNAMES.urlChange, LOGINURL);
                    alert(result.message || '第三方登录失败，请刷新页面重试');
                }
            } catch (error) {
                cookie.del('IF_OTK', '/', '.ifeng.com');
                alert('第三方登录失败，请刷新页面重试');
            }
        }
    }, 300);
};

/**
 * 弹出登录框，流程：
 * @param {String} LoginDialog 的id，用于指定打开弹窗。
 *
 * 1. 开启登录检测
 * 2. 开启实名检测
 * 3. 开启第三方检测
 * 4. 根据用户是否登录和实名来确定弹窗中iframe的地址（如果用户已登录但是未实名，则赋值为实名认证地址，其他情况登录地址）
 * 5. 触发自定义事件 dialogOpen
 */
export const login = function login(id) {
    checkLogin();
    checkOTK();
    checkReal();
    const src = isLogin() && !isReal() ? LOGINMOB : LOGINURL;

    event.trigger(EVENTNAMES.dialogOpen, src, id);
};

/**
 * 关闭登录框，流程：
 *
 * 1. 清除登录检测
 * 2. 清除实名检测
 * 3. 清除第三方登录检测
 * 4. 触发自定义事件 dialogClose
 */
export const closeDialog = function closeDialog() {
    clearInterval(LOGINTIMER);
    clearInterval(REALTIMER);
    clearInterval(OTKTIMER);
    event.trigger(EVENTNAMES.dialogClose);
};

/**
 * 用户登出，流程：
 *
 * 1. 调用登出接口
 *
 * 请求成功，返回 code 为 1
 * 2. 根据登出接口返回的 result.data.turl 列表创建 iframe 进行依次访问
 * 3. 调用定时器去查询用户是否已经不是登录状态
 * 4. 如果不是登录状态，则触发自定义事件logout，并将创建的 iframe 移除
 * 5. 开启登录检测，这样用户在其他页面登录，此页面也可以更新状态
 *
 * 请求成功，返回 code 不为 1
 * 2. 判断是否有 message， 有的话，弹出失败原因
 *
 * 请求失败
 * 2. 弹出失败提示
 */
// export const logout = async function logout() {
//     try {
//         const result = await jsonp(LOGOUTURL, {
//             jsonpCallback: '__logoutCallback',
//             cache: false,
//         });

//         if (result.code === 1) {
//             const container = document.createElement('div');

//             for (const url of result.data.turl) {
//                 const iframe = document.createElement('iframe');

//                 iframe.src = url;
//                 iframe.style.display = 'none';
//                 container.appendChild(iframe);
//             }

//             document.body.appendChild(container);
//             clearInterval(LOGOUTTIMER);
//             LOGOUTTIMER = setInterval(() => {
//                 if (!isLogin()) {
//                     clearInterval(LOGOUTTIMER);
//                     event.trigger(EVENTNAMES.logout);
//                     container.parentNode.removeChild(container);
//                     checkLogin();
//                 }
//             }, 300);
//         } else if (result.message) {
//             alert(result.message);
//         }
//     } catch (error) {
//         alert('用户退出失败，请稍后重试');
//     }
// };

/**
 * 用户登出，不是真的登出，只是将当前浏览器的cookie清除，造成当前浏览器登出的现象，避免将其他端的登录状态也清除掉。
 * 流程：
 *
 * 1. 清除cookie
 * 2. 开启登录检测，这样用户在其他页面登录，此页面也可以更新状态
 */
export const logout = function logout() {
    cookie.del('sid', '/', '.ifeng.com');
    clearInterval(LOGOUTTIMER);
    LOGOUTTIMER = setInterval(() => {
        if (!isLogin()) {
            clearInterval(LOGOUTTIMER);
            event.trigger(EVENTNAMES.logout);
            checkLogin();
        }
    }, 300);
};

/**
 * 远程验证sid的状态。
 * @param {string} sid
 *
 * @returns {
 *      guid:用户唯一id
 *      realNameStatus: 0 实名 1 未实名
 *      res: 没用
 * }
 */
export const remoteChecklogin = async function remoteChecklogin(sid) {
    try {
        const result = await jsonp(CHECKLOGINURL, {
            data: {
                sid,
            },
            jsonpCallback: '__checkloginCallback',
            cache: false,
        });

        return result.code === 1 ? result.data : {};
    } catch (error) {
        return {};
    }
};
